import { alpha, Box, Typography, useTheme } from '@mui/material';

import type { StatusLight } from '../../types';

import { STATUS_CONFIG } from './eligibilityStatusConfig';

interface EligibilityStatusBannerProps {
  statusLight: StatusLight;
}

export function EligibilityStatusBanner({ statusLight }: EligibilityStatusBannerProps) {
  const theme = useTheme();
  const config = STATUS_CONFIG[statusLight];
  const Icon = config.icon;
  const color = theme.palette[config.palette].main;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        p: 1.5,
        borderRadius: 1,
        bgcolor: alpha(color, 0.08),
        mb: 2,
      }}
    >
      <Icon sx={{ color, fontSize: 20, flexShrink: 0 }} />
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {config.guidance}
      </Typography>
    </Box>
  );
}
